<template>
  <v-container fluid>
    <v-row dense>
      <v-col v-for="game in games" :key="game.code" cols="6">
        <v-card>
          <v-list-item>
            <v-list-item-avatar color="grey">
              <v-img class="elevation-6" :src="provider.img"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="headline">{{ game.name }}</v-list-item-title>
              <v-list-item-subtitle>by {{ provider.name }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-img :src="game.img" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px" />

          <v-card-actions>
            <v-btn color="orange" text @click="playGame(game, 'real')" v-if="logged">
              Play
            </v-btn>
            <v-btn color="orange" text @click="playGame(game, 'fun')">
              Play for fun
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="gamedialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card height="100%" v-if="selectedGame">

        <v-toolbar dark color="primary" height="24">
          <v-toolbar-title>{{ selectedGame.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeGame()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <iframe :src="getUrl()" allowfullscreen webkitallowfullscreen mozallowfullscreen frameborder=0 height="93%" width="100%"></iframe>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  mounted(){
    this.$store.dispatch('getGames', this.$store.state.selectedProvider.id);
  },
  computed: {
    token() {
      return this.$store.state.login.token;
    },
    logged() {
      return this.$store.state.login.logged;
    },
    games() {
      return this.$store.state.games || [];
    },
    channel() {
      return this.$isMobile() ? 'mobile' : 'desktop';
    },
    provider() {
      return this.$store.state.selectedProvider;
    }
  },
  data: () => ({
    gamedialog: false,
    selectedGame: null,
    mode: 'fun',
  }),
  methods: {
    closeGame() {
      this.gamedialog = false;
    },
    playGame(game, mode) {
      this.gamedialog = true;
      this.selectedGame = game;
      this.mode = mode;
    },
    getUrl() {
      if (this.mode === 'fun') {
        return `${process.env.VUE_APP_WALLET_URL}/casino/viewer?operator=MON&gameid=${this.selectedGame.code}&mode=${this.mode}&lang=es&lobby=https://casino-demo.emaraplay.com/&channel=${this.channel}`;
      } else {
        return `${process.env.VUE_APP_WALLET_URL}/casino/viewer?operator=MON&token=${this.token}&gameid=${this.selectedGame.code}&mode=${this.mode}&lang=es&lobby=https://casino-demo.emaraplay.com/&channel=${this.channel}`;
      }
    }, 
  }
}
</script>
